import { useScrollIntoView } from '../../../../../hooks'
import { FormFieldsContainer } from '../../../../Form'
import {
  FLAT_FORM_FIELD_NAME_CONTRACT_ID,
  FLAT_FORM_FIELD_NAME_CONTRACT_START_DATE,
  FLAT_FORM_FIELD_NAME_INHABITANT,
  FLAT_FORM_FIELD_NAME_PURCHASE_CONTRACT_NUMBER,
} from '../../FlatForm.constants'
import { getFlatFormContractFieldName } from '../../FlatForm.utils'
import { ContractIdField } from '../ContractIdField'
import { ContractStartDateField } from '../ContractStartDateField'
import { InhabitantField } from '../InhabitantField'
import { PurchaseContractNumberField } from '../PurchaseContractNumberField'

import * as styles from './Fields.module.css'

// Should be standalone component for correct work `useScrollIntoView`
function Fields({ index }) {
  const { ref } = useScrollIntoView()

  return (
    <FormFieldsContainer className={styles.fieldsContainer} ref={ref}>
      <InhabitantField
        name={getFlatFormContractFieldName(
          index,
          FLAT_FORM_FIELD_NAME_INHABITANT
        )}
      />
      <ContractIdField
        name={getFlatFormContractFieldName(
          index,
          FLAT_FORM_FIELD_NAME_CONTRACT_ID
        )}
      />
      <PurchaseContractNumberField
        name={getFlatFormContractFieldName(
          index,
          FLAT_FORM_FIELD_NAME_PURCHASE_CONTRACT_NUMBER
        )}
      />
      <ContractStartDateField
        name={getFlatFormContractFieldName(
          index,
          FLAT_FORM_FIELD_NAME_CONTRACT_START_DATE
        )}
      />
    </FormFieldsContainer>
  )
}

export default Fields
